import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryInvalidNumberOfYears extends AnnualSummaryError {
    numberOfYears;
    constructor(numberOfYears, options) {
        super('The number of years is not a number', options);
        this.numberOfYears = numberOfYears;
    }
}
export default AnnualSummaryInvalidNumberOfYears;
